import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Sider } from 'components/ui/index';
import { connect } from 'react-redux';
import { setWidth, resetWidth } from '../flow/actions';


const defaultProps = {
  collapsed: false,
  collapsible: false,
  position: 'left',
  minWidth: 10,
  width: 300,
  style: {},
  children: null,
};
const propTypes = {
  collapsed: PropTypes.bool,
  collapsible: PropTypes.bool,
  position: PropTypes.oneOf(['left', 'right', 'top', 'bottom']),
  minWidth: PropTypes.number,
  width: PropTypes.number,
  style: PropTypes.object,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node
  ])
};

class EnhancedSider extends Component {
  constructor(props) {
    super(props);
    this.state = {
      collapsed: props.collapsed,
    };
  }
  componentDidMount() {
    // NOTES: Sync config width to redux when mounting.
    //        because width can be varied by setting, it's impossible to set a default width value in reducer.
    this.props.setWidth(this.props.position, this.getWidthByState(this.state.collapsed));
  }
  componentWillUnmount() {
    this.props.resetWidth(this.props.position);
  }
  getWidthByState = (collapsing) => {
    const { minWidth, width } = this.props;
    return collapsing ? minWidth : width;
  }
  toggleSiderState = () => {
    const collapsing = !this.state.collapsed;
    this.setState({ collapsed: collapsing });
    this.props.setWidth(this.props.position, this.getWidthByState(collapsing));
  }

  render() {
    const { collapsed } = this.state;
    // TODO: reconsider what should be computed in this level.
    const siderConfigs = {
      ...this.props,
      collapsed,
      style: {
        ...this.props.style,
        width: this.getWidthByState(collapsed),
      },
      onToggleClick: this.toggleSiderState,
    };

    return <Sider {...siderConfigs} />;
  }
}

const mapStateToProps = null;
const mapDispatchToProps = {
  setWidth,
  resetWidth,
};
EnhancedSider.defaultProps = defaultProps;
EnhancedSider.propTypes = propTypes;
export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(EnhancedSider);



// WEBPACK FOOTER //
// ./src/components/page/EnhancedSider/container/index.jsx